import React from "react";
import FieldToggle from "../../components/FieldToggle/";

export default ({label, name, value, onChange, description, disabled}) => (
  <div className="row middle-xs padding-vertical-15">
    <div className="col-sm-4 col-md-3">
      <FieldToggle name={name} value={value} onChange={onChange} label={label} disabled={disabled} />
    </div>
    <div className="col-sm-8 col-md-9">{description}</div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Permissions/index.jsx